export const API_BASE_URL = process.env.REACT_APP_API_BASE_URL || 'https://api.mindax.cn/api/v1';

export const API_ENDPOINTS = {
  // 认证
  LOGIN: '/admin/auth/login',
  PROFILE: '/admin/auth/profile',
  
  // 仪表板
  DASHBOARD_OVERVIEW: '/admin/dashboard/overview',
  DASHBOARD_STATS: '/admin/dashboard/stats',
  DASHBOARD_ACTIVITY: '/admin/dashboard/recent-activity',
  
  // 管理员用户 (APP端用户管理)
  ADMIN_USERS: '/admin/users',
  ADMIN_USER_STATS: '/admin/users/stats/overview',
  
  // 后台管理员账号
  ADMIN_MANAGEMENT: '/admin/management',
  ADMIN_MANAGEMENT_STATS: '/admin/management/stats/overview',
  
  // 设备管理
  ADMIN_DEVICES: '/admin/devices',
  ADMIN_DEVICE_STATS: '/admin/devices/stats/overview',
  ADMIN_DEVICE_EXPORT: '/admin/devices/export',

  // 只读诊断
  ADMIN_DEVICE_BINDING_DIAGNOSTICS: '/admin/diagnostics/device-binding',
  
  // 家庭管理（管理员接口）
  FAMILIES: '/admin/families',

  // 应用版本管理
  ADMIN_UPGRADE: '/admin/upgrade',
  
  // 应用商店配置管理
  ADMIN_STORE_CONFIG: '/admin/upgrade/store-config',
  ADMIN_STORE_CONFIG_INIT: '/admin/upgrade/store-config/init',

  // 协议管理
  ADMIN_POLICY: '/admin/policy',

  // 支付管理
  PAYMENT_OVERVIEW: '/admin/payments/overview',
  PAYMENT_ORDERS: '/admin/payments/orders',
  PAYMENT_TRANSACTIONS: '/admin/payments/transactions',
  PAYMENT_REFUNDS: '/admin/payments/refunds',

  // 短信管理
  SMS_RECORDS: '/admin/sms',
  SMS_STATISTICS: '/admin/sms/statistics',

  // 套餐管理
  PRODUCTS: '/admin/products',

  // 用户反馈管理
  FEEDBACK_LIST: '/admin/feedback/list',
  FEEDBACK_DETAIL: '/admin/feedback/:id',
  FEEDBACK_UPDATE_STATUS: '/admin/feedback/:id/status',
  FEEDBACK_BATCH_UPDATE_STATUS: '/admin/feedback/batch/status',
  FEEDBACK_ADD_REPLY: '/admin/feedback/:id/log',

  // FAQ管理
  FAQ_LIST: '/admin/faq',
  FAQ_CREATE: '/admin/faq',
  FAQ_DETAIL: '/admin/faq/:id',
  FAQ_UPDATE: '/admin/faq/:id',
  FAQ_DELETE: '/admin/faq/:id',

  // 通知管理
  NOTIFICATION_LIST: '/admin/notifications/list',
  NOTIFICATION_CREATE: '/admin/notifications',
  NOTIFICATION_STATS: '/admin/notifications/statistics',
  NOTIFICATION_DETAIL: '/admin/notifications/:id',
  NOTIFICATION_UPDATE: '/admin/notifications/:id',
  NOTIFICATION_DELETE: '/admin/notifications/:id',
  NOTIFICATION_REVOKE: '/admin/notifications/:id/revoke',

  // 通知受众预设
  NOTIFICATION_AUDIENCE_LIST: '/admin/notification-audiences',
  NOTIFICATION_AUDIENCE_CREATE: '/admin/notification-audiences',
  NOTIFICATION_AUDIENCE_DETAIL: '/admin/notification-audiences/:id',
  NOTIFICATION_AUDIENCE_UPDATE: '/admin/notification-audiences/:id',
  NOTIFICATION_AUDIENCE_DELETE: '/admin/notification-audiences/:id',
  NOTIFICATION_AUDIENCE_PREVIEW: '/admin/notification-audiences/:id/preview-count',

  // 开发者工具配置
  ADMIN_DEV_TOOLS: '/admin/dev-tools',
  ADMIN_DEV_TOOLS_INIT: '/admin/dev-tools/init',

  // 钱包管理
  ADMIN_WALLET_USER: '/admin/wallets/user/:userId',
  ADMIN_WALLET_FAMILY_LOGS: '/admin/wallets/family/:familyId/logs',
  ADMIN_WALLET_SYNC_LOGS: '/admin/wallets/sync-logs',
  ADMIN_WALLET_FAMILY_RECHARGE: '/admin/wallets/family/:familyId/recharge',
  ADMIN_WALLET_STATS: '/admin/wallets/stats/overview',
  ADMIN_WALLET_POINTS_GUIDE: '/admin/wallets/points-guide',

  // Banner管理
  ADMIN_BANNERS: '/admin/banners',
  ADMIN_BANNER_DETAIL: '/admin/banners/:id',
  ADMIN_UPLOAD_IMAGE: '/admin/upload/image',
  
  // 公开Banner接口
  PUBLIC_BANNERS: '/banners',

  // 功能权限管理
  ADMIN_FEATURE_PERMISSIONS: '/admin/feature-permissions',

  // 特性可见性管理
  ADMIN_FEATURE_VISIBILITY: '/admin/feature-visibility',

  // 审计日志
  ADMIN_AUDIT_EVENTS: '/admin/audit-events',

  // 会员配额管理
  ADMIN_MEMBERSHIP_QUOTAS: '/admin/membership-quotas',

  // 订阅管理
  ADMIN_SUBSCRIPTIONS: '/admin/subscriptions',
  ADMIN_SUBSCRIPTIONS_STATS: '/admin/subscriptions/stats',

  // 邀请管理
  ADMIN_INVITATION_RECORDS: '/admin/invitations/records',
  ADMIN_INVITATION_RECORDS_BATCH_SUSPICIOUS: '/admin/invitations/records/batch/suspicious',
  ADMIN_INVITATION_REWARDS: '/admin/invitations/rewards',
  ADMIN_INVITATION_RULES: '/admin/invitations/rules',
  ADMIN_INVITATION_STATS: '/admin/invitations/stats',
  ADMIN_INVITATION_LEADERBOARD: '/admin/invitations/leaderboard',

  // 中台计费代理
  PLATFORM_BILLING_BALANCE: '/admin/platform/billing/families/:familyId/balance',
  PLATFORM_BILLING_TOPUP: '/admin/platform/billing/families/:familyId/topup',
  PLATFORM_BILLING_ADJUST: '/admin/platform/billing/families/:familyId/adjust',
  PLATFORM_BILLING_PRICING: '/admin/platform/billing/pricing',


  // 兑换码管理
  ADMIN_REDEMPTION_BATCHES: '/admin/redemption/batches',
  ADMIN_REDEMPTION_BATCH_DETAIL: '/admin/redemption/batches/:id',
  ADMIN_REDEMPTION_BATCH_GENERATE: '/admin/redemption/batches/:id/generate',
  ADMIN_REDEMPTION_BATCH_EXPORT: '/admin/redemption/batches/:id/export',
  ADMIN_REDEMPTION_BATCH_REVOKE: '/admin/redemption/batches/:id/revoke',
  ADMIN_REDEMPTION_CODES: '/admin/redemption/codes',
  ADMIN_REDEMPTION_CODES_REVOKE: '/admin/redemption/codes/revoke',
  ADMIN_REDEMPTION_STATS: '/admin/redemption/stats',
  ADMIN_REDEMPTION_STATS_CHANNEL: '/admin/redemption/stats/by-channel',
  ADMIN_REDEMPTION_STATS_TYPE: '/admin/redemption/stats/by-type',
  ADMIN_REDEMPTION_STATS_TREND: '/admin/redemption/stats/trend',

  // 营销配置管理
  ADMIN_MARKETING_CONFIGS: '/admin/marketing/configs',
  ADMIN_MARKETING_CONFIGS_BATCH: '/admin/marketing/configs',
  ADMIN_MARKETING_CONFIGS_REFRESH: '/admin/marketing/configs/refresh',
  ADMIN_MARKETING_CONFIGS_AUDIT: '/admin/marketing/configs/audit-log',
  ADMIN_CAMPAIGN_H5: '/admin/campaign-h5',
  CAMPAIGN_H5: '/campaign/h5',
  ADMIN_CAMPAIGN_FORMS: '/admin/campaign-forms',
  CAMPAIGN_SURVEYS: '/campaign-surveys',

  // 活动会员赠送（可配置天数/人群/时段）
  ADMIN_CAMPAIGN_CONFIG: '/admin/membership/campaign/config',
  ADMIN_CAMPAIGN_CLAIMS: '/admin/membership/campaign/claims',

  // 签到积分规则管理
  ADMIN_CHECKIN_RULES: '/admin/checkin/rules',

  // 换货管理
  EXCHANGE_LIST: '/exchanges',
  EXCHANGE_DETAIL: '/exchanges', // + /:id
  EXCHANGE_APPROVE: '/exchanges', // + /:id/approve
  EXCHANGE_CONFIRM_RECEIVED: '/exchanges', // + /:id/confirm-received
  EXCHANGE_SHIP: '/exchanges', // + /:id/ship
  EXCHANGE_COMPLETE: '/exchanges', // + /:id/complete
  EXCHANGE_FAIL_INSPECTION: '/exchanges', // + /:id/fail-inspection

  // 熏听管理
  ADMIN_XUNTING_MUSIC: '/admin/platform/xunting/music',
  ADMIN_VOICE_CLONE_LIST: '/admin/platform/voice-clone/families/:familyId/voices',
  ADMIN_VOICE_CLONE_CREATE: '/admin/platform/voice-clone/families/:familyId/voices',
  ADMIN_VOICE_CLONE_TASK: '/admin/platform/voice-clone/families/:familyId/tasks/:taskId',
  ADMIN_VOICE_CLONE_DETAIL: '/admin/platform/voice-clone/families/:familyId/voices/:voiceName',
  ADMIN_VOICE_CLONE_EXTRA: '/admin/platform/voice-clone/families/:familyId/voices/:voiceName/extra',

  // 家庭云管理
  CLOUD_STATS: '/admin/cloud/stats',
  CLOUD_QUOTAS: '/admin/cloud/quotas', // GET列表, /:familyId读取/更新家庭覆盖与购买增量
  CLOUD_QUOTA_POLICIES: '/admin/cloud/quota-policies', // 等级基础容量策略
  CLOUD_RESOURCES: '/admin/cloud/resources', // GET列表, /:id操作, /:id/audit审核
  CLOUD_RESOURCES_PENDING: '/admin/cloud/resources/pending', // 待审核列表
  CLOUD_ALBUMS: '/admin/cloud/albums', // GET列表, /:id删除
  CLOUD_TRASH_STATS: '/admin/cloud/trash/stats', // 回收站统计
  CLOUD_TRASH_CLEANUP: '/admin/cloud/trash/cleanup', // 清理回收站
  CLOUD_SYNTHESIS_TASKS: '/admin/cloud/synthesis-tasks', // AI 故事合成任务: GET列表, /stats统计, /:id详情, /:id/reimport重投落盘, /:id/retry重跑合成

  // 退货管理
  RETURN_LIST: '/admin/returns',
  RETURN_DETAIL: '/admin/returns', // + /:id
  RETURN_APPROVE: '/admin/returns', // + /:id/approve
  RETURN_CONFIRM_RECEIVED: '/admin/returns', // + /:id/confirm-received
  RETURN_INSPECT: '/admin/returns', // + /:id/inspect
  RETURN_INITIATE_REFUND: '/admin/returns', // + /:id/complete
};
